import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

// export const ModalHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 15px;
`;

export const CloseIcon = styled.img`
  cursor: pointer;
`;

export const CardWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 24px;
  justify-content: center;
`;

export const RoleCard = styled.button`
  width: 220px;
  height: 300px;
  border-radius: 1px;
  border: 1px solid #4948ac;
  cursor: pointer;
  background: rgb(243, 244, 248);
  color: #4948ac;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  transition: all 0.25s ease;

  &:hover {
    background: #4948ac;
    color: #ffffff;
  }

  /* Icon swap logic */
  &:hover .default {
    display: none;
  }

  &:hover .hover {
    display: block;
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 16px;

  .icon {
    width: 56px;
    height: 56px;
  }

  .hover {
    display: none;
  }
`;

export const Subtitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 700;
  margin-top: 6px;
`;
